import React, { useState } from "react";
import axios from "axios";
import {
    AESEncryption,
    ApiResDecrypt,
    handleInputChange,
} from "../../CommonMethhods/CommonMethods";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import Loader from "../../Components/Common/Loader";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { HNISERVICESURL } from "../../Configuration/Telecaller_URl";
import hniSearch from '../../asset/images/hniSearch.svg';
import download from '../../asset/images/download-brokrage.svg';
function TelecallerHni() {
    const [showTable, setShowTable] = useState(false);
    const [clientDetailsResponse, setClientDetailsResponse] = useState({});
    const [noData, setNoData] = useState("");
    const [loader, setLoader] = useState(false);
    const numberchema = Yup.object().shape({
        numberAndRef: Yup.string()
            .required("Please enter Your Number ")
            .matches(
                /^[A-Za-z0-9]{10}$/,
                "Number will be 10 digits"
            ),
    });
    const {
        register: regesterNumberInput,
        handleSubmit: handleSubmitNumber,
        formState: { errors: numberError },
        setValue: setNumberVal,
        getValues: getNumberValues,
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(numberchema),
    });

    const storeToken = localStorage.getItem("ssoToken");
    if (storeToken == null) {
        window.location.replace("/");
    }
    function showDetails(data) {
        localStorage.setItem("teleUserNumber", data.numberAndRef)
        disableButtonFor3Seconds();
        clientsDetails(data.numberAndRef, true);
    }
    const disableButtonFor3Seconds = () => {
        var apiButton = document.getElementById("apiButton");
        apiButton.disabled = true;
        setTimeout(function () {
            apiButton.disabled = false;
        }, 3000);
    };
    const clientsDetails = async (data) => {
        setLoader(true);
        let clientPayLoad = {
            mobile: data || clientDetailsResponse.mobile,
            userId: localStorage.getItem("userId"),
        };
        let encPayload = AESEncryption(clientPayLoad);
        try {
            const response = await axios.post(
                `${HNISERVICESURL.GetClientStatus}`,
                encPayload,

                {
                    headers: {
                        "content-Type": "application/json",
                        reserv: 1,
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                    },
                }
            );
            const data = await response.data;
            let hniGetDetailsResponse = ApiResDecrypt(data);
            console.log(hniGetDetailsResponse, "hniGetDetailsResponse");
            if (hniGetDetailsResponse?.status === 1) {
                setNoData(hniGetDetailsResponse.message);
                setClientDetailsResponse({})
                setShowTable(false);
            } else {
                if (hniGetDetailsResponse.data !== null) {
                    setClientDetailsResponse(hniGetDetailsResponse?.data);
                    setShowTable(true);
                    setNoData("");
                }
                else {

                }

            }
        } catch (err) {
            console.log(err);
            setShowTable(false);
            if (err?.request?.status == "401") {
                // setSession(true);
            } else {
                // setSession(false);
                setNoData("Something went wrong");
            }
        } finally {
            setLoader(false);
        }
    };
    console.log(clientDetailsResponse, "ClientDetailsResponse");

    return (
        <>
            <Header portal={"TELECALLER"} />
            <SingleSignOnSideBar />
            <main id="main-content" className="telecallerDash">
                <div className="telecaller">
                    <div className="card-box">
                        <div className="title-section">
                            <h2 className="card-title">Client Application Status</h2>
                        </div>
                        <div action="" className="">
                            <form className="row telecaller-form" onSubmit={handleSubmitNumber(showDetails)}>
                                <div className="col-md-4 col-sm-4 col-12">
                                    <div className="form-group">
                                        <img className="hniSearch-icon" src={hniSearch} alt="hniSearch" height={"15px"} width={"15px"} />
                                        <input
                                            type="text"
                                            id="FromDate"
                                            placeholder="Enter Mobile Number"
                                            onInput={(e) => {
                                                setNoData("");
                                                setShowTable(false);
                                                handleInputChange(e)
                                            }}
                                            style={{ paddingLeft: '22px' }}
                                            {...regesterNumberInput("numberAndRef")}
                                            className={`form-control ${numberError?.numberAndRef ? "is-invalid" : ""
                                                }`}
                                            autoComplete="off"
                                            maxLength={10}
                                        />
                                        <div className="invalid-feedback number-field">
                                            {numberError.numberAndRef?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-4 col-12">
                                    <button
                                        value="submit"
                                        className="send-message hni"
                                        id="apiButton"
                                    >
                                        Search
                                    </button>
                                </div>
                            </form>
                            {loader ? (
                                <div className="loader-alignment">
                                    <Loader />
                                </div>
                            ) : (
                                <>
                                    {showTable ? (
                                        <div className="hni-table">
                                            <div className="download-data">
                                                <div className="btn-hni" style={{ display: "none" }}>
                                                    <img src={download} alt="download" height={"16px"} width={"16px"} />
                                                    <button className="download-hni">Download</button>
                                                </div>
                                            </div>
                                            <div className="table-responsive scroll-table telecaller-table-wrapper resume-table">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th className="table-head sl-no" >Sr. No</th>
                                                            <th className="table-head" >Mobile Number</th>
                                                            <th className="table-head" >PAN Number</th>
                                                            <th className="table-head" >Client Code</th>
                                                            <th className="table-head" >Client Name</th>
                                                            <th className="table-head" >Application Status</th>
                                                            {clientDetailsResponse.applicationStatus.toLowerCase()== "rejected" && <th className="table-head" >Rejection Reason</th>}
                                                            <th className="table-head" >Status Date</th>
                                                            <th className="table-head" >Branch Code</th>
                                                            <th className="table-head" >RM Name</th>
                                                            <th className="table-head" >Client Status</th>
                                                            <th className="table-head" >DP Account No.</th>
                                                            <th className="table-head" style={{ width: "140px" }}>Account Op. Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ height: "unset" }}>
                                                        <tr>
                                                            <td className="table-value" style={{ width: "70px" }}>{"01"}</td>
                                                            <td className="table-value">{clientDetailsResponse.mobile}</td>
                                                            <td className="table-value">{clientDetailsResponse.pan}</td>
                                                            <td className="table-value">{clientDetailsResponse.clientCode}</td>
                                                            <td className="table-value">{clientDetailsResponse.cName}</td>
                                                            <td className="table-value" style={{ color: "rgba(0, 186, 0, 1)" }}>{clientDetailsResponse.applicationStatus}</td>
                                                            {clientDetailsResponse.applicationStatus.toLowerCase() == "rejected" && <td className="table-value">{clientDetailsResponse.rejectionReason}</td>}
                                                            <td className="table-value">{clientDetailsResponse.statusDate}</td>
                                                            <td className="table-value">{clientDetailsResponse.branchCode}</td>
                                                            <td className="table-value">{clientDetailsResponse.rmName}</td>
                                                            <td className="table-value">{clientDetailsResponse.clientStatus}</td>
                                                            <td className="table-value">{clientDetailsResponse.dpAccountNo}</td>
                                                            <td className="table-value" style={{ width: "140px" }}>{clientDetailsResponse.accountOpenDate}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <p className="no-data-found">{noData}</p>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                    </div>

                </div>

            </main>

        </>
    );
}
export default TelecallerHni;
